import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected, useTheme } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ResetPassword from "@/pages/ResetPassword";
import ConfirmEmail from "@/pages/ConfirmEmail";
import CourierRun from "@/pages/CourierRun";
import CourierPickup from "@/pages/CourierPickup";
import BoyPortal from "@/pages/boy/BoyPortal";
import BoyMerchantSignup from "@/pages/boy/BoyMerchantSignup";
import BoyCourierSignup from "@/pages/boy/BoyCourierSignup";
import BoyRide from "@/pages/boy/BoyRide";
import BoyTrack from "@/pages/boy/BoyTrack";
import BoyExpress from "@/pages/BoyExpress";
import BoyConfig from "@/pages/BoyConfig";
import Dashboard from "@/pages/Dashboard";
import POS from "@/pages/POS";
import TablesFloor from "@/pages/TablesFloor";
import Preorders from "@/pages/Preorders";
import Comandas from "@/pages/Comandas";
import ComandaView from "@/pages/ComandaView";
import Tickets from "@/pages/TicketsPage";
import PrintJobsPage from "@/pages/PrintJobsPage";
import PublicPanel from "@/pages/PublicPanel";
import CallPanel from "@/pages/CallPanel";
import Parking from "@/pages/ParkingPage";
import Delivery from "@/pages/Delivery";
import RatingsPage from "@/pages/Ratings";
import Loyalty from "@/pages/Loyalty";
import MenuAdmin from "@/pages/MenuSettings";
import PublicMenu from "@/pages/PublicMenuEntry";
import Products from "@/pages/Products";
import Customers from "@/pages/Customers";
import Reports from "@/pages/Reports";
import SettingsPage from "@/pages/Settings";
import CompanyPage from "@/pages/Company";
import UsersPage from "@/pages/UsersPage";
import TicketSale from "@/pages/TicketSale";
import SoldItems from "@/pages/SoldItems";
import Plans from "@/pages/Plans";
import AdminPanel from "@/pages/AdminPanel";
import Stock from "@/pages/Stock";
import CashPage from "@/pages/CashPage";
import Production from "@/pages/Production";
import PaymentReturn from "@/pages/PaymentReturn";
import { AppGate } from "@/components/PayOnlyShell";
import Landing from "@/pages/Landing";
import MobileShell from "@/pages/mobile/MobileShell";
import MHome from "@/pages/mobile/MHome";
import MPdv from "@/pages/mobile/MPdv";
import MComandas from "@/pages/mobile/MComandas";
import MNewComanda from "@/pages/mobile/MNewComanda";
import MComandaMenu from "@/pages/mobile/MComandaMenu";
import MProducts from "@/pages/mobile/MProducts";
import MCart from "@/pages/mobile/MCart";
import MComandaOrders from "@/pages/mobile/MComandaOrders";
import MClose from "@/pages/mobile/MClose";
import MOrders from "@/pages/mobile/MOrders";
import MSales from "@/pages/mobile/MSales";
import MDelivery from "@/pages/mobile/MDelivery";
import MRelease from "@/pages/mobile/MRelease";
import MPrints from "@/pages/mobile/MPrints";
import MBackup from "@/pages/mobile/MBackup";
import MNotifications from "@/pages/mobile/MNotifications";
import MConfig from "@/pages/mobile/MConfig";
import MSupport from "@/pages/mobile/MSupport";
import MDirectSale from "@/pages/mobile/MDirectSale";
import MDirectCart from "@/pages/mobile/MDirectCart";
import MDirectPay from "@/pages/mobile/MDirectPay";
import { DirectGuard } from "@/components/mobile/DirectGuard";
import MPrivacy from "@/pages/mobile/MPrivacy";
import MLinkLogin from "@/pages/mobile/MLinkLogin";
import MWelcome from "@/pages/mobile/MWelcome";
import MobileLinks from "@/pages/MobileLinks";
import Referrals from "@/pages/Referrals";
import PartnerSignup from "@/pages/partners/PartnerSignup";
import PartnerAccess from "@/pages/partners/PartnerAccess";
import PartnerPanel from "@/pages/partners/PartnerPanel";
import Fiscal from "@/pages/Fiscal";
import Folha from "@/pages/Folha";
import Ponto from "@/pages/Ponto";
import Ajuda from "@/pages/Ajuda";
import Contabil from "@/pages/Contabil";
import MeuContador from "@/pages/MeuContador";
import ContadorEntrar from "@/pages/ContadorEntrar";
import FiscalAdmin from "@/pages/FiscalAdmin";
import { configurarFiscal } from "@/fiscal";
import { getToken, getAdminToken } from "@/lib/api";

configurarFiscal({
  getToken: () => (window.location.pathname.startsWith("/fiscal/admin") ? getAdminToken() : getToken()),
  caminhoCertificado: "/app/sistema/empresa",
  caminhoEmpresa: "/app/sistema/empresa",
});

function ThemeBoot() {
  useTheme();
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ThemeBoot />
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Signup />} />
          <Route path="/redefinir-senha" element={<ResetPassword />} />
          <Route path="/confirmar-email" element={<ConfirmEmail />} />
          <Route path="/entregador/coleta/:token" element={<CourierPickup />} />
          <Route path="/entregador/:token" element={<CourierRun />} />
          <Route path="/boy/corrida/:token" element={<BoyRide />} />
          <Route path="/boy/rastreio/:token" element={<BoyTrack />} />
          <Route path="/boy/:code/lojista" element={<BoyMerchantSignup />} />
          <Route path="/boy/:code/motoboy" element={<BoyCourierSignup />} />
          <Route path="/boy/:code" element={<BoyPortal />} />
          <Route path="/cardapio/:slug" element={<PublicMenu />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/fiscal/admin" element={<Navigate to="/fiscal/admin/integracao" replace />} />
          <Route path="/fiscal/admin/:pagina" element={<FiscalAdmin />} />
          <Route path="/parceiros/cadastro/:invite" element={<PartnerSignup />} />
          <Route path="/parceiros/entrar" element={<PartnerAccess />} />
          <Route path="/parceiros/painel/:token" element={<PartnerPanel />} />
          <Route path="/painel/:slug" element={<PublicPanel />} />
          <Route path="/chamada/:slug" element={<CallPanel />} />
          <Route path="/app" element={<Protected><AppGate /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="pdv" element={<POS />} />
            <Route path="mesas" element={<TablesFloor />} />
            <Route path="encomendas" element={<Preorders />} />
            <Route path="comandas" element={<Comandas />} />
            <Route path="comandas/:id" element={<ComandaView />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="impressoes" element={<PrintJobsPage />} />
            <Route path="estacionamento" element={<Parking />} />
            <Route path="delivery" element={<Delivery />} />
            <Route path="boy-express" element={<BoyExpress />} />
            <Route path="boy-express/config" element={<BoyConfig />} />
            <Route path="avaliacoes" element={<RatingsPage />} />
            <Route path="fidelidade" element={<Loyalty />} />
            <Route path="cardapio" element={<MenuAdmin />} />
            <Route path="produtos" element={<Products />} />
            <Route path="estoque" element={<Stock />} />
            <Route path="caixa" element={<CashPage />} />
            <Route path="producao" element={<Production />} />
            <Route path="clientes" element={<Customers />} />
            <Route path="relatorios" element={<Reports />} />
            <Route path="fiscal/*" element={<Fiscal />} />
            <Route path="folha/*" element={<Folha />} />
            <Route path="ponto" element={<Ponto />} />
            <Route path="ajuda" element={<Ajuda />} />
            <Route path="contabil" element={<Contabil />} />
            <Route path="sistema/contador" element={<MeuContador />} />
            <Route path="configuracoes" element={<SettingsPage />} />
            <Route path="sistema/empresa" element={<CompanyPage />} />
            <Route path="sistema/usuarios" element={<UsersPage />} />
            <Route path="indicacoes" element={<Referrals />} />
            <Route path="venda-ticket" element={<TicketSale />} />
            <Route path="consulta-itens" element={<SoldItems />} />
            <Route path="acesso-movel" element={<MobileLinks />} />
            <Route path="planos" element={<Plans />} />
            <Route path="pagamento/retorno" element={<PaymentReturn />} />
          </Route>
          <Route path="/contador/entrar/:codigo" element={<ContadorEntrar />} />
          <Route path="/m/entrar/:token" element={<MLinkLogin />} />
          <Route path="/m" element={<Protected><MobileShell /></Protected>}>
            <Route index element={<MHome />} />
            <Route path="pdv" element={<MPdv />} />
            <Route path="comandas" element={<DirectGuard><MComandas /></DirectGuard>} />
            <Route path="nova" element={<DirectGuard><MNewComanda /></DirectGuard>} />
            <Route path="comanda/:id" element={<DirectGuard><MComandaMenu /></DirectGuard>} />
            <Route path="comanda/:id/produtos" element={<DirectGuard><MProducts /></DirectGuard>} />
            <Route path="comanda/:id/carrinho" element={<DirectGuard><MCart /></DirectGuard>} />
            <Route path="comanda/:id/pedidos" element={<DirectGuard><MComandaOrders /></DirectGuard>} />
            <Route path="comanda/:id/fechar" element={<DirectGuard><MClose /></DirectGuard>} />
            <Route path="pedidos" element={<DirectGuard><MOrders /></DirectGuard>} />
            <Route path="vendas" element={<MSales />} />
            <Route path="delivery" element={<MDelivery />} />
            <Route path="liberacao" element={<MRelease />} />
            <Route path="impressoes" element={<MPrints />} />
            <Route path="backup" element={<MBackup />} />
            <Route path="notificacoes" element={<MNotifications />} />
            <Route path="config" element={<MConfig />} />
            <Route path="suporte" element={<MSupport />} />
            <Route path="venda-direta" element={<MDirectSale />} />
            <Route path="venda-direta/carrinho" element={<MDirectCart />} />
            <Route path="venda-direta/pagamento" element={<MDirectPay />} />
            <Route path="privacidade" element={<MPrivacy />} />
            <Route path="primeiro-acesso" element={<MWelcome />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
